import React from 'react';

import UndoIcon from 'ggApp/shared/icons/Undo';
import Tooltip from 'ggApp/shared/containers/tooltip';
import { PureTranslator } from 'ggApp/modules/translator';

import { Wrapper, IconWrapper, TextWrapper, ToolTipText } from './styles';

export const LongRevocation = ({
    className,
    revocationPeriodVariant,
}: {
    className?: string;
    revocationPeriodVariant: string;
}): JSX.Element => {
    const revocationText =
        revocationPeriodVariant === '14-day'
            ? { badgeText: '14_DAY_REVOCATION_TEXT', tooltipText: '14_DAY_REVOCATION_TOOLTIP_TEXT' }
            : {
                  badgeText: '30_DAY_REVOCATION_TEXT',
                  tooltipText: '30_DAY_REVOCATION_TOOLTIP_TEXT',
              };
    return (
        <Wrapper className={className}>
            <IconWrapper>
                <UndoIcon />
            </IconWrapper>
            <TextWrapper>
                <PureTranslator tk={revocationText.badgeText} />
                <Tooltip tooltipTK={revocationText.tooltipText}>
                    <ToolTipText>
                        <PureTranslator tk="REVOCATION_PERIOD" />
                    </ToolTipText>
                </Tooltip>
            </TextWrapper>
        </Wrapper>
    );
};
